import { MarcoTrainingAndImprovementStatusDTO } from 'business/models/Models';
import RMButton from 'components/customComponents/Controls/RMButton';
import { RMCheckBoxY } from 'components/customComponents/Controls/RMCheckbox';
import RMModal from 'components/modal/RMModal';
import React, { memo, useCallback, useState } from 'react';
import './setup.css';
import { FmlxButton } from 'fmlx-common-ui';
interface Props {
  sendStatisticsOptionStatus: boolean;
  setSendStatisticsOptionStatus: (isSendStatisticsOptionStatus: boolean) => void;
  collectRetrainingImagesStatus: MarcoTrainingAndImprovementStatusDTO;
  setCollectRetrainingImagesStatus: (
    isCollectRetrainingImagesStatus: MarcoTrainingAndImprovementStatusDTO,
  ) => void;
}
export const ImprovementOptions = memo((props: Props) => {
  const {
    sendStatisticsOptionStatus,
    setSendStatisticsOptionStatus,
    collectRetrainingImagesStatus,
    setCollectRetrainingImagesStatus,
  } = props;
  const [showModal, setShowModal] = useState<boolean>(false);
  const onClickYes = useCallback(() => {
    setShowModal(false);
    const collection = new MarcoTrainingAndImprovementStatusDTO();
    collection.autoCollectRetrainingImages = true;
    collection.collectRetrainingImages = true;
    setCollectRetrainingImagesStatus(collection);
  }, []);
  const onClickNo = useCallback(() => {
    setShowModal(false);
    setCollectRetrainingImagesStatus(
      new MarcoTrainingAndImprovementStatusDTO({
        collectRetrainingImages: true,
        autoCollectRetrainingImages: false,
      }),
    );
  }, []);
  const onClickCancel = useCallback(() => {
    setShowModal(false);
  }, []);
  const onUncheck = useCallback(() => {
    setCollectRetrainingImagesStatus(
      new MarcoTrainingAndImprovementStatusDTO({
        collectRetrainingImages: false,
        autoCollectRetrainingImages: false,
      }),
    );
  }, []);

  return (
    <div id='improvementoptions-wrapper' className="border-box mt-2 ml-1 float-left p-0 improvement-options-box">
      <label id='improvementoptions-label' className="row m-2 font-weight-bold">Improvement Options</label>
      <div id="improvementoptions-statistics-row" className="row col-lg-12">
        <div id="improvementoptions-statistics-checkbox-container" className="col-lg-1">
          <RMCheckBoxY
            isChecked={sendStatisticsOptionStatus}
            onChange={() => setSendStatisticsOptionStatus(!sendStatisticsOptionStatus)}
          />
        </div>
        <label id="improvementoptions-statistics-label" className="p-1 col-lg-11">
          Automatically send usage statistics to Formulatrix
        </label>
      </div>
      <div id="improvementoptions-marco-row" className="row col-lg-12">
        <div id="improvementoptions-marco-checkbox-container" className="col-lg-1">
          <RMCheckBoxY
            isChecked={collectRetrainingImagesStatus?.collectRetrainingImages}
            onChange={(e) => (e === true ? setShowModal(true) : onUncheck())}
          />
        </div>
        <RMModal
          id="improvementoptions-marco-modal"
          showModal={showModal}
          setShowModal={setShowModal}
          body={
            <div id="improvementoptions-marco-modal-body"  style={{ width: '100%' }}>
              <label id="improvementoptions-marco-modal-label">
                ROCK MAKER can automatically send images to improve MARCO, do you want to
                participate?
              </label>
              <div id="improvementoptions-marco-modal-buttons" className="d-flex justify-content-center">
                <div id="improvementoptions-marco-button-wrapper-yes" className="p-1">
                  <RMButton
                    id="improvementoptions-marco-button-yes"
                    onClick={() => onClickYes()}
                    className="setup-btn-outline-yellow-wide btn-outline-yellow-wide"
                    label="Yes"
                    variant={FmlxButton.Variant.OUTLINE}
                  />
                </div>
                <div id="improvementoptions-marco-button-wrapper-no" className="p-1">
                  <RMButton
                    id="improvementoptions-marco-button-no"
                    onClick={() => onClickNo()}
                    className="setup-btn-outline-yellow-wide btn-outline-yellow-wide"
                    label="No"
                    variant={FmlxButton.Variant.OUTLINE}
                  />
                </div>
                <div id="improvementoptions-marco-button-cancel" className="p-1">
                  <RMButton
                    id="improvementoptions-marco-button-cancel"
                    onClick={() => onClickCancel()}
                    className="setup-btn-outline-yellow-wide btn-outline-yellow-wide"
                    label="Cancel"
                    variant={FmlxButton.Variant.OUTLINE}
                  />
                </div>
              </div>
            </div>
          }
          heading="Marco Training"
          showButtons={false}
        />
        <label id="improvementoptions-marco-training-label" className="p-1 col-lg-11">
          Send images for MARCO training and improvement
        </label>
      </div>
    </div>
  );
});
